module.exports = __webpack_public_path__ + "img/0S6A9820.91420582.jpg";